import TableList from "@components/templates/tablelist";
import comIndex from './update';
import { mapState, mapGetters } from "vuex";
import {
    HttpGetStorageAllocationList,
    HttpWarehouse
} from '@/service/storageallocation';
export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // 'quanbu': 0,
                    // 'IN_orderStatus':null,
                }
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            warehouseList: []
        }
    },
    async mounted () {
        await HttpWarehouse().then(res => {
            this.warehouseList = res.data.map(item => {
                return {
                    value: item.id,
                    label: item.title,
                    attach: {
                        ...item
                    }
                }
            })
        }, err => {
            this.$VMessage.error(err.message);
        })
    },
    computed: {
        ...mapGetters("dictionary", [
            "getOrgList",
            "getBillcusorgList",
            "getBillcusAndFbaWareList",
            "getUserManageWarehouseList"
        ]),
        ToolsData() {
            return [
                {
                    name: "添加分配",
                    operate: "add",
                    theme: "primary",
                },{
                    name: "批量导出",
                    operate: "export",
                    theme: "info",
                    // batch: true,
                }
            ]
        },
        SearchsData() {
            let style = 'width: 130px;';
            return [
                {
                    label: "客户",
                    tag: 'Select',
                    key: 'EQ_organizationId',
                    options: this.getBillcusorgList,
                    show: true,
                    style: style,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: '仓库',
                    tag: 'Select',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getUserManageWarehouseList,
                    show: true,
                    style: style,
                    props: {
                        filterable: true,
                    }
                }
            ]
        },
        columns() {
            return [{
                title: '操作',
                width: 70,
                render: this.getOperateNodes,
                // fixed: 'left'
            }, {
                title: '客户',
                key: 'organizationId',
                sortable: true,
                render: (h, { row }) => {
                    let orgName = this.getBillcusorgList.filter(item => {
                        return item.value === row.organizationId
                    })[0] || '--';
                    if (orgName !== '--') {
                        orgName = orgName.label;
                    }
                    return <div>{orgName}</div>
                }
                
            }, {
                title: '仓库',
                sortable: true,
                key: 'orgWarehouseCode'
            }, {
                title: '仓库名称',
                render: (h, { row }) => {
                    let warehouseName = this.getBillcusAndFbaWareList.filter(item => {
                        return item.value === row.orgWarehouseCode
                    })[0] || '--';
                    if (warehouseName !== '--') {
                        warehouseName = warehouseName.attach.title;
                    }
                    return <div>{warehouseName}</div>
                }
            },{
                title: '总库容',
                key: 'totalCapacity'
            }, {
                title: '分配比例',
                key: 'capacity',
                render:(h, { row }) => {
                    let capacityQty = row.capacity+"%"
                    return <div>{capacityQty}</div>
                }
            },{
                title: '可使用库容',
                key: 'usedCapacity'
            }]
        }
    },
    methods: {
        ajaxRequest: HttpGetStorageAllocationList,
        getOperateNodeMap(row) {
            const { id, orderStatus } = row
            return [
                {
                    label: '查看',
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: '编辑',
                    show: true,
                    params: id,
                    operate: 'edit'
                }]
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'add': {
                    let url = this.$router.resolve({
                        name: "allocationDetailUpdate",
                        params: { type: "add" },
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'query': {
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        type: 'query',
                        showFooter: false
                    }
                    break;
                }
                case 'edit': {
                    let url = this.$router.resolve({
                        name: "allocationDetailUpdate",
                        params: { type: "edit" },
                        query: {
                            id: params
                        }
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/warehoseCapacity/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'get',
                    })
                    break;
            }
        }
    }
}